/** Config de nav por perfil de negocio (CRUD admin) — cache en memoria (TTL 2 min). */

export type ProfileNavFlags = Map<string, boolean>; // navPath → enabled

const profileNavCache = { data: null as Map<string, ProfileNavFlags> | null, at: 0 };

/**
 * Matriz completa por perfil (incluye enabled=false).
 * Si un path no figura → el caller debe caer al filtro estático onlyProfiles.
 */
export async function fetchProfileNavConfig(): Promise<Map<string, ProfileNavFlags>> {
  if (profileNavCache.data && Date.now() - profileNavCache.at < 120_000) {
    return profileNavCache.data;
  }
  const r = await fetch("/api/profile-nav");
  if (!r.ok) throw new Error("nav config fetch failed");
  const rows = (await r.json()) as { businessProfile: string; navPath: string; enabled: boolean }[];
  const map = new Map<string, ProfileNavFlags>();
  for (const row of rows) {
    if (!map.has(row.businessProfile)) map.set(row.businessProfile, new Map());
    map.get(row.businessProfile)!.set(row.navPath, row.enabled);
  }
  profileNavCache.data = map;
  profileNavCache.at = Date.now();
  return map;
}
